import React from 'react';
import ReactDOM from 'react-dom';
import Game from './Game';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Game />
  </React.StrictMode>,
  document.getElementById('root')
);